module.exports = __webpack_public_path__ + "media/x_foximaxi_k.65206658.mp3";